export const brandVideos = [
  {
    video: "https://youtu.be/WYf13Cjsn_U",
    name: "Larry King's Valentines Short Film (2025)",
  },
  {
    video: "https://youtu.be/ZV9WAWkJFiM",
    name: "Larry King | Twitch Trailer (2024)",
  },
  {
    video: "https://youtu.be/W2Nuy44387I",
    name: "Milan Art Institute Promotional Video (2024)",
  },
];

export const businessContentExamples = [
  {
    video: "https://youtu.be/W2Nuy44387I",
    name: "Milan Art Institute Promotional Video (2024)",
    label: "Brand storytelling",
  },
  {
    video: "https://youtu.be/ZV9WAWkJFiM",
    name: "Larry King | Twitch Trailer (2024)",
    label: "Commercial-style promo",
  },
  {
    video: "https://youtu.be/WYf13Cjsn_U",
    name: "Larry King's Valentines Short Film (2025)",
    label: "Cinematic announcement video",
  },
];

export const artistHighlights = [
  {
    video: "https://youtu.be/eSUXcPoFfFk",
    name: "g3urin & zvch - SWAG (2026)",
  },
  {
    video: "https://youtu.be/lPmL8z8Gvtg",
    name: "JALLEN - Close2Me (2025)",
  },
  {
    video: "https://youtu.be/KS4_tDKtdO8",
    name: "g3urin - CSTRAIGHT (2025)",
  },
  {
    video: "https://youtu.be/khfa2qF-OhU",
    name: "g3urin - STACKDATMONEY (feat. zvch) (2025)",
  },
  {
    video: "https://youtu.be/j2EI0QqPM9o",
    name: "Nathan Coles Jr | 2023 Director's Reel",
  },
  {
    video: "https://youtu.be/Ehji3GWqdPk",
    name: "2019 - 2022 Music Video Reel",
  },
];

export const selectedWork = [
  {
    video: "https://youtu.be/eSUXcPoFfFk",
    name: "g3urin & zvch - SWAG (2026)",
  },
  {
    video: "https://youtu.be/WYf13Cjsn_U",
    name: "Larry King's Valentines Short Film (2025)",
  },
  {
    video: "https://youtu.be/W2Nuy44387I",
    name: "Milan Art Institute Promotional Video (2024)",
  },
  {
    video: "https://youtu.be/ZV9WAWkJFiM",
    name: "Larry King | Twitch Trailer (2024)",
  },
  {
    video: "https://youtu.be/uMQWhwzTf7g",
    name: "weluvmax - MEANLUV (2024)",
  },
  {
    video: "https://youtu.be/9O6WXdV6O6w",
    name: "ItsKaz - Sierra (2024)",
  },
  {
    video: "https://youtu.be/bxGatYWD9SM",
    name: "ItsKaz - Pretty To Me (2024)",
  },
  {
    video: "https://youtu.be/j2EI0QqPM9o",
    name: "Nathan Coles Jr | 2023 Director's Reel",
  },
];

export const allWorkVideos = [
  {
    video: "https://youtu.be/eSUXcPoFfFk",
    name: "g3urin & zvch - SWAG (2026)",
  },
  {
    video: "https://youtu.be/lPmL8z8Gvtg",
    name: "JALLEN - Close2Me (2025)",
  },
  {
    video: "https://youtu.be/KS4_tDKtdO8",
    name: "g3urin - CSTRAIGHT (2025)",
  },
  {
    video: "https://youtu.be/khfa2qF-OhU",
    name: "g3urin - STACKDATMONEY (feat. zvch) (2025)",
  },
  {
    video: "https://youtu.be/WYf13Cjsn_U",
    name: "Larry King's Valentines Short Film (2025)",
  },
  {
    video: "https://youtu.be/ZV9WAWkJFiM",
    name: "Larry King | Twitch Trailer (2024)",
  },
  {
    video: "https://youtu.be/W2Nuy44387I",
    name: "Milan Art Institute Promotional Video (2024)",
  },
  {
    video: "https://youtu.be/uMQWhwzTf7g",
    name: "weluvmax - MEANLUV (2024)",
    private: true,
  },
  {
    video: "https://youtu.be/9O6WXdV6O6w",
    name: "ItsKaz - Sierra (2024)",
  },
  {
    video: "https://youtu.be/bxGatYWD9SM",
    name: "ItsKaz - Pretty To Me (2024)",
  },
  {
    video: "https://youtu.be/9E1QpZEMc1Y",
    name: "zvch - Element (OG Version)",
  },
  {
    video: "https://youtu.be/j2EI0QqPM9o",
    name: "Nathan Coles Jr | 2023 Director's Reel",
  },
  {
    video: "https://youtu.be/Ehji3GWqdPk",
    name: "2019 - 2022 Music Video Reel",
  },
  {
    video: "https://youtu.be/8lIFKY3rLbo",
    name: "zvch - Focus",
  },
  {
    video: "https://youtu.be/7k33OA0bAcM",
    name: "weluvmax - Hooters",
    private: true,
  },
  {
    video: "https://youtu.be/pBd6fgJe7vs",
    name: "ItsKaz - & WakeUpWill - Rev It!",
  },
  {
    video: "https://youtu.be/HiGa4kSyqVI",
    name: "g3urin - Medusa",
  },
  {
    video: "https://youtu.be/LfYk-rbA9KE",
    name: "ItsKaz - Tequila Onna Island",
  },
  {
    video: "https://youtu.be/Zv48hEFqWA4",
    name: "zvch - Polur feat. g3urin",
  },
  {
    video: "xCTjTPsmhCI",
    name: "zvch - Element",
  },
  {
    video: "e2Atkthjg2o",
    name: "ItsKaz - Sorry 4 It",
  },
  {
    video: "ubUTJd881mw",
    name: "weluvmax - 30 Coats",
    private: true,
  },
  {
    video: "MVB5nhlEE_g",
    name: "ItsKaz - Die Nvr",
  },
  {
    video: "PE6oYeqBcdE",
    name: "weluvmax - Red Mini Coop",
    private: true,
  },
  {
    video: "sDSR_v_K8cE",
    name: "Doxycodone - London Bridges",
  },
  {
    video: "DqKvuDxJsqQ",
    name: "weluvmax - Lucky Freestyle",
    private: true,
  },
  {
    video: "5wasJ5kpFvU",
    name: "weluvmax - REDREDRED",
    private: true,
  },
  {
    video: "wu6dyASmPyo",
    name: "Will Metty - Nemesis",
  },
  {
    video: "Z9HmSaJ68G8",
    name: "NyTheKid - Down Bad",
  },
  {
    video: "VEtgpuTourY",
    name: "weluvmax & Doxycodone (feat. Will Metty) - DRIP DRIP",
    private: true,
  },
  {
    video: "ichVAc6HOcE",
    name: "Will Metty & Doxycodone - Slide Thru",
  },
  {
    video: "HLfFhD88JMo",
    name: "Will Metty & Doxycodone - Nonsensical Rap",
  },
  {
    video: "3fi1sDTPlIo",
    name: "GoddessK - Big Boss",
  },
  {
    video: "R4_uOy4dqhI",
    name: "CTP $coop & PBN Majji - Never Fail",
  },
  {
    video: "it9mq8rlKAE",
    name: "NyTheKid - Style",
  },
  {
    video: "xOLbhg9JFoI",
    name: "NyTheKid - Wookies",
  },
  {
    video: "YXAUqchVDvM",
    name: "I Need Summo",
  },
  {
    video: "Twwrqpxh72k",
    name: "Cash A Check (feat. CTP $coop) - PBN Majji",
  },
  {
    video: "DiTSQDdMAn0",
    name: "DXEAM - Kickstarter",
  },
  {
    video: "T0y5K0nHB8E",
    name: "Intro - MariFromDa2",
  },
];
